import { render, staticRenderFns } from "./Prestockage.vue?vue&type=template&id=88ffa51e&"
import script from "./Prestockage.vue?vue&type=script&lang=js&"
export * from "./Prestockage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports